import { Component, Input } from "@angular/core";
import { ChatMessageType } from "../chat-window/chat-window.component";
import * as moment from "moment";

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
  @Input() public message: ChatMessageType;
  @Input() public senderName: string;
  constructor() {}

  formatDate(date: string) {
    return moment(new Date(date).toISOString()).fromNow(true);
  }
}